module.exports = __webpack_public_path__ + "assets/img/enterIcon2.7cd7338a.png";